import { putInitiateFlowApi } from './put-initiate-flow.config';

export const {
  putInitiateFlow,
  putInitiateFlowSuccess,
  putInitiateFlowError,
  putInitiateFlowClear,
  putInitiateFlowActions,
} = putInitiateFlowApi;
